import React from "react";
import { Link } from "react-router-dom";
import { FileText, ArrowRight } from "lucide-react";

const AdministrativeService = () => {
  return (
    <div className="bg-gray-100 min-h-screen">
      <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold mb-8 text-gray-800">
          Administrative Service
        </h1>
        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <div className="flex items-center mb-4">
            <FileText className="w-12 h-12 text-red-500 mr-4" />
            <p className="text-xl text-gray-700">
              Support for your office and administrative functions.
            </p>
          </div>
          <p className="text-gray-600 mb-4">
            Our Administrative Service provides skilled professionals to support
            your office operations and administrative tasks. From reception to
            data entry, we ensure your business runs smoothly and efficiently.
          </p>
          <h2 className="text-2xl font-semibold mb-4 text-gray-800">
            How It Works
          </h2>
          <ol className="list-decimal list-inside mb-6 text-gray-700">
            <li className="mb-2">
              We assess your administrative support needs
            </li>
            <li className="mb-2">
              Our team sources qualified administrative professionals
            </li>
            <li className="mb-2">
              We present candidates with relevant skills and experience
            </li>
            <li className="mb-2">
              You select the best fit for your organization
            </li>
            <li>We provide ongoing support and performance monitoring</li>
          </ol>
          <Link
            to="/contact"
            className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors inline-flex items-center text-lg font-semibold"
          >
            Get Started <ArrowRight className="ml-2 w-5 h-5" />
          </Link>
        </div>
      </main>
    </div>
  );
};

export default AdministrativeService;
